import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

// Lädt Layout + verfügbare Dachbild-Quellen; das Bild selbst erst, wenn der Editor offen ist.
export function useRoofLayout(projectId, enabled) {
  const [meta, setMeta] = useState(null);
  const [source, setSource] = useState(null);
  const [img, setImg] = useState(null);
  const [imgError, setImgError] = useState("");

  const load = useCallback(() => api.get(`/projects/${projectId}/pv-layout`)
    .then((r) => { setMeta(r.data); return r.data; })
    .catch(() => toast.error("Modulbelegung konnte nicht geladen werden")), [projectId]);
  useEffect(() => { load(); }, [load]);

  const uploadPath = meta?.layout?.upload_path;
  useEffect(() => {
    if (!enabled || !source) { setImg(null); return undefined; }
    let alive = true;
    let url;
    setImg(null);
    setImgError("");
    api.get(`/projects/${projectId}/pv-layout/image`, { params: { source }, responseType: "blob" })
      .then((r) => {
        url = URL.createObjectURL(r.data);
        const im = new Image();
        im.onload = () => alive && setImg({ url, w: im.naturalWidth, h: im.naturalHeight, source });
        im.src = url;
      })
      .catch(() => alive && setImgError("Dachbild konnte nicht geladen werden – bitte ein eigenes Foto hochladen."));
    return () => { alive = false; if (url) URL.revokeObjectURL(url); };
  }, [projectId, source, uploadPath, enabled]);

  return { meta, setMeta, source, setSource, img, imgError };
}
